import { AnalysisReportRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AnalysisIndexRoute() {
  const { workspaceId } = Route.useParams();
  return <AnalysisReportRoute segment="analysis" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/')({
  component: AnalysisIndexRoute,
});
